import React from "react";
import Navigation from "./Navbar";
import Footer from "./Footer";
import pic1 from "../image/Picture11.png";
import pic2 from "../image/Picture12.png";
import pic3 from "../image/Picture13.png";
import pic4 from "../image/Picture14.jpg";
import AbhitabhGupta from "../image/AbhitabhGupta.jpg";
import AmitUJain from "../image/AmitU.Jain.jpg";
import ArchanaDevrari from "../image/ArchanaDevrari.jpg";
import AshishIndani from "../image/AshishIndani.jpg";
import AtantraDasGupta from "../image/AtantraDasGupta.png";
import binusharma from "../image/binusharma.jpg";
import gauravAgarwal from "../image/gauravAgarwal.png";
import GirishJoshi from "../image/GirishJoshi.jpg";
import GoutamBhattacharya from "../image/GoutamBhattacharya.png";
import KMadan from "../image/K.Madan.jpg";
import MymoonaAkhtar from "../image/MymoonaAkhtar.jpg";
import PSChandranand from "../image/P.S.Chandranand.jpg";
import RajeshCShah from "../image/RajeshC.Shah.png";
import RajivChhibber from "../image/RajivChhibber.jpg";
import RaviGaur from "../image/RaviGaur.jpg";
import SachinAgrawal from "../image/SachinAgrawal.jpg";
import SampaBanerjee from "../image/SampaBanerjee.png";
import ShivakiranMakam from "../image/ShivakiranMakam.png";
import suchitbajaj from "../image/suchitbajaj.jpg";
import sunilkhetrapal from "../image/sunilkhetrapal.jpg";


const Advisory = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Navigation */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Navigation />
      </div>

      {/* Hero Section */}
      <section className="pt-[190px] lg:pt-[200px] px-4 sm:px-6 md:px-12 lg:px-20 text-blue-900">
        <div className="max-w-6xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-blue-900 to-blue-700 mb-6">
            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Our Distinguished <span className="text-orange-500">Mentors</span>
          </h1>

          <p className="text-lg md:text-xl max-w-3xl mx-auto">
            Guiding our mission with unparalleled expertise, experience, and vision for global public health transformation.
          </p>
        </div>
      </section>

      {/* Advisors Grid */}
      <section className="py-[60px] px-4 sm:px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Advisor Card Component */}
          {[
            {
              img: pic1,
              name: "Mr. A. Natarajan",
              role: "Assistant High Commissioner of India in Kandy (Retd.)",
             
              list: [
                "Former Director (CPV-C) at MEA, New Delhi",
                "Former Consul General to Phuentsholing, Jaffna, Sri Lanka"
              ],
               desc: "Seasoned diplomat with extensive experience in international relations and cross-border collaborations.",
            },
            {
              img: pic2,
              name: "Mr. Deepak Chandra Misra",
              role: "Advisor (IT), Department of Administrative Reforms and Public Grievances (DARPG), Govt. of India",
              list: [
                "Former Advisor (IT) with Department of Land Resources, Govt of India",
                "Former Dy. Director General, National Informatics Centre (NIC) Govt of India"
              ],
              desc: "IT policy expert with deep experience in government technology transformation and digital governance.",
            },
            {
              img: pic3,
              name: "H.E. Prof. (Dr.) K. C. Jankee, GOSK",
              role: "President - WASME",
              
              list: [
                "Former Ambassador of Mauritius to Germany and Russia",
                "Director - Global Rise Ltd."
              ],
              desc: "Distinguished academic and diplomat with global perspective on sustainable development.",
            },
            {
              img: pic4,
              name: "Dr. S.Venkataramanaiah",
              role: "Professor, Operations and Supply Chain Management",
              
              list: [  "Professor,Indian Institute of Management, Lucknow, U.P. India. ",
              
                "Fulbright Scholar-USA, 2009"
              ],
              desc: "Renowned scholar in supply chain management with international academic collaborations.",
            },
              {
    img: gauravAgarwal,
    name: "Mr. Gaurav Agarwal",
    role: "Managing Director, Innvolution Healthcare Pvt. Ltd.",
    list: [
      "Recipient: National Innovation Award by President of India",
      "Featured in 21 Young Asian Entrepreneurs by Asia One",
      "Featured in Forbes Marquee Edition"
    ],
  },
  {
    img: RajivChhibber,
    name: "Dr. Rajiv Chhibber",
    role: "Vice President – External Affairs, Sahajanand Medical Technologies Ltd.",
    list: [
      "Expert – Healthcare Policy & Strategist",
      "Global Health Diplomacy & Media Communications"
    ],
  },
  {
    img: KMadan,
    name: "Dr. K. Madan Gopal",
    role: "Advisor - Public Health Administration, NHSRC, MoHFW, Government of India",
    list: [
      "Former Senior Consultant, NITI Aayog, Government of India",
      "Worked on Rashtriya Swasthya Bima Yojana (RSBY)",
      "Worked on Ayushman Bharat"
    ],
  },
  {
    img: sunilkhetrapal,
    name: "Dr. Sunil Khetarpal",
    role: "Deputy Director General, Association of Healthcare Providers - India (AHPI)",
    list: [],
  },
  {
    img: RaviGaur,
    name: "Dr. Ravi Gaur",
    role: "Director & Chair Medical Advisory Committee – Oncquest Labs",
    list: [
      "Founder & Director, DRG Path Labs (UNI DRG Specialty Laboratory - LLP), Delhi",
      "Chairman Medical Advisory Committee, Unipath Specialty Laboratory Ltd, Ahmedabad"
    ],
  },
  {
    img: GoutamBhattacharya,
    name: "Mr. Goutam Bhattacharya",
    role: "Chief Executive Officer, Life Sciences Sector Skill Development Council (LSSSDC)",
    list: [
      "Joint Apprenticeship Advisor, National Apprentice Promotional Scheme (NAPS)"
    ],
  },
  {
    img: RajeshCShah,
    name: "Dr. Prof. Rajesh C. Shah",
    role: "Founder President, FILMEI",
    list: [
      "Former leadership roles: Indian Medicolegal & Ethics Association",
      "World Association of Laparoscopic Surgeons",
      "Indian Society of Wound Management",
      "Indian Hernia Society",
      "Society of Endoscopy & Laparo Surgeons of India – Gujarat",
      "Advisory Member: International College of Robotic Surgeons"
    ],
  },
  {
    img: suchitbajaj,
    name: "Dr. Shuchin Bajaj",
    role: "Board Member, National Accreditation Board for Hospitals and Healthcare (NABH)",
    list: [
      "Founder Director, Ujala Cygnus Hospitals, New Delhi"
    ],
  },
  {
    img: PSChandranand,
    name: "Dr. P. S. Chandranand",
    role: "Director, IQZYME Medtech Private Limited",
    list: [
      "WHO PQ and regulatory intelligence advocacy and mentorship",
      "Expert in regulatory testing of biologics, IVDs and MedTech innovation"
    ],
  },
  {
    img: ShivakiranMakam,
    name: "Dr. Shivakiran Makam",
    role: "General Manager, Healthcare Global Enterprises Ltd.",
    list: [
      "Former CEO, Atal Incubation Centre, Sri Krishnadevaraya University",
      "Supported by NITI Aayog, Government of India"
    ],
  },
  {
    img: SachinAgrawal,
    name: "Dr. Sachin Agrawal",
    role: "Assoc. Director – Heading Generative AI, PepsiCo",
    list: [
      "Earlier headed Artificial Intelligence (AI), Sony AI Research"
    ],
  },
  {
    img: AtantraDasGupta,
    name: "Mr. Atantra Das Gupta",
    role: "HealthTech & MedTech Expert",
    list: [],
  },
  {
    img: AshishIndani,
    name: "Dr. Ashish Indani",
    role: "General Manager – MedTech, Zydus MedTech",
    list: [
      "Author of 'Essentials of Medical Device Clinical Research'"
    ],
  },
  {
    img: GirishJoshi,
    name: "Dr. Girish Joshi",
    role: "Chief Executive Officer, Vitamed Healthcare",
    list: [
      "Former General Manager - India & South Asia, Medline India"
    ],
  },
  {
    img: AmitUJain,
    name: "Dr. Amit U. Jain",
    role: "Founder & CEO, HospitalSoftwareShop.com",
    list: [],
  },
  {
    img: binusharma,
    name: "Col. Binu Sharma",
    role: "Executive Director, Lone Star Holdings Private Limited",
    list: [
      "Former Senior Director Nursing – Max Healthcare Institute",
      "Former Senior VP – Nursing Service, Columbia Asia Hospitals Pvt. Ltd."
    ],
  },
  {
    img: SampaBanerjee,
    name: "Dr. Sampa Banerjee",
    role: "Executive Director, World Association for Small and Medium Enterprises (WASME)",
    list: [
      "Secretary, Society for Advancement of Village Economy (SAVE)"
    ],
  },
  {
    img: MymoonaAkhtar,
    name: "Prof. Mymoona Akhtar",
    role: "Director – CTSI, Jamia Hamdard",
    list: [
      "Honorary Secretary – Indian Pharmaceutical Association, Delhi State Branch"
    ],
  },
  {
    img: ArchanaDevrari,
    name: "Ms. Archana Devrari",
    role: "Hospital Procurement & Supply Chain Expert",
    list: [
      "Vendor Management",
      "Tendering",
      "Inventory Control"
    ],
  },
  {
    img: AbhitabhGupta,
    name: "Dr. Abhitabh Gupta",
    role: "Chief Business Executive, ACE Insurance Brokers Pvt. Ltd.",
    list: [],
  }
          ].map((advisor, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition"
            >
              <div className="flex flex-col md:flex-row items-center p-6 gap-6">
                
                {/* Circular Image */}
                <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-blue-100 shadow-md">
                  <img
                    src={advisor.img}
                    alt={advisor.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Content */}
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-blue-50 text-blue-800 mb-2">
                    Our Distinguished Mentor
                  </span>

                  <h3 className="text-xl md:text-2xl font-bold text-blue-900">
                    {advisor.name}
                  </h3>

                  <p className="text-blue-600 font-medium text-sm mb-3">
                    {advisor.role}
                  </p>

                 

                  <ul className="space-y-2">
                    {advisor.list.map((item, i) => (
                      <li key={i} className="flex items-start text-sm text-gray-600">
                        <span className="text-green-500 mr-2">✔</span>
                        {item}
                      </li>
                    ))}
                  </ul>

                   <p className="text-gray-600 text-sm mb-4 mt-[12px]">
                    {advisor.desc}
                  </p>
                </div>

              </div>
            </div>
          ))}

        </div>

        {/* Advisory Note */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 text-center">
          <h3 className="text-2xl font-bold text-blue-900 mb-4">
            The Role of Our Advisory Mentors
          </h3>
          <p className="text-gray-700 max-w-4xl mx-auto text-lg">
            Our advisory members provide strategic guidance, validate research directions,
            and help connect our initiatives with global best practices.
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Advisory;
